import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import RegisteredAction from 'src/app/model/registered-action';
import { User } from 'src/app/model/user';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../base.service';

@Injectable({
  providedIn: 'root',
})
export class GetPrintworkAndAtelierInfoForSubProjectControllerRequestService {
  private static BASE_URL = '/immo/getPrintworkAndAtelierInfo';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) => res as PrintworkAndAtelierInfo;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      GetPrintworkAndAtelierInfoForSubProjectControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getPrintworkAndAtelierInfoForSubProject(
    subProjectId: number
  ): Promise<PrintworkAndAtelierInfo> {
    return this.get(`/${subProjectId}`, this.deserialize).toPromise();
  }
}

export interface PrintworkAndAtelierInfo {
  subProjectId: number;

  mostRecentPrintRelatedRegisteredAction: RegisteredAction;

  atelierEmployeeUser: User;

  printWorkFinished: boolean;

  atelierFinished: boolean;

  lastAtelierOperationAt: Date;
}
